import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b053d40"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar seleção", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = { class: "ss-carregando-usuarios" }
const _hoisted_10 = { class: "ss-usuario-encontrados-perfil" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.state.computedVisivel,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.computedVisivel) = $event)),
      width: 600
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.props.titulo), 1)
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmarSelecaoUsuarios && _ctx.confirmarSelecaoUsuarios(...args)))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "Empresas",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_empresa, {
                      codigosSelecionados: _ctx.state.empresasSelecionadas,
                      "onUpdate:codigosSelecionados": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.empresasSelecionadas) = $event)),
                      varias: true,
                      onChange: _ctx.obterListaPerfilUsuario
                    }, null, 8, ["codigosSelecionados", "onChange"])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.props.apresentarEmpresas]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.props.apresentarEmpresas?'ant-col ant-col-xs-24 ant-col-xl-12':'ant-col ant-col-xs-24 ant-col-xl-24')
              }, [
                _createVNode(_component_a_form_item, {
                  label: "Perfil",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.state.perfisSelecionados,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.perfisSelecionados) = $event)),
                      class: "ss-tamanho-completo",
                      placeholder: "Selecione",
                      optionFilterProp: "label",
                      mode: "multiple",
                      options: _ctx.state.listaPerfis,
                      onChange: _ctx.pesquisarUsuario
                    }, null, 8, ["value", "options", "onChange"])
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_form_item, {
                  label: "",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "250",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.nomeUsuario) = $event)),
                      onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.pesquisarUsuario && _ctx.pesquisarUsuario(...args))),
                      placeholder: "Digite o nome do usuário"
                    }, null, 544), [
                      [_vModelText, _ctx.state.nomeUsuario]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createVNode(_component_a_alert, {
                  message: _ctx.state.mensagem,
                  class: "ss-margin-campos ss-mensagem-personalizada",
                  type: _ctx.state.tipoMensagem,
                  "show-icon": ""
                }, null, 8, ["message", "type"]), [
                  [_vShow, _ctx.state.mensagem !== '']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_spin, { size: "large" })
                ], 512), [
                  [_vShow, _ctx.state.carregando]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaUsuariosAgrupados, (perfil) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "ss-usuarios-encontrados ss-margin-campos",
                    key: perfil.codigoPerfil
                  }, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.state.selecionarTodosUsuarios,
                      "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.selecionarTodosUsuarios) = $event)),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selecionarTodosUsuarios($event.target.checked)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Selecionar todos usuários ")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_checkbox, {
                        class: "ss-fonte-negrito",
                        checked: perfil.selecionado,
                        "onUpdate:checked": ($event: any) => ((perfil.selecionado) = $event),
                        onClick: ($event: any) => (_ctx.selecionarUsuariosPerfil(perfil.codigoPerfil,$event.target.checked)),
                        onChange: _ctx.verificaSelecaoTodosUsuarios
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(perfil.descricaoPerfil), 1)
                        ]),
                        _: 2
                      }, 1032, ["checked", "onUpdate:checked", "onClick", "onChange"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(perfil.usuarios, (usuario) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "ss-usuario-encontrados-item",
                        key: usuario.codigoUsuario
                      }, [
                        _createVNode(_component_a_checkbox, {
                          checked: usuario.selecionado,
                          "onUpdate:checked": ($event: any) => ((usuario.selecionado) = $event),
                          onChange: ($event: any) => (_ctx.checarUsuariosPerfil(perfil.codigoPerfil))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(usuario.codigoUsuario) + " - " + _toDisplayString(usuario.nomeUsuario), 1)
                          ]),
                          _: 2
                        }, 1032, ["checked", "onUpdate:checked", "onChange"])
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}